import script from "./VODAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./VODAnalytics.vue?vue&type=script&setup=true&lang=js"

import "./VODAnalytics.vue?vue&type=style&index=0&id=82b78bae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82b78bae"]])

export default __exports__